const notificationsBackofficeRoutes = [
  {
    path: '',
    name: 'Notifications',
    meta: {
      title: {
        en: 'Notifications',
        ru: 'Уведомления',
      },
      authorize: [],
    },
    component: () => import(/* webpackChunkName: 'BackofficeNotifications' */ '../components/pages/Notifications.vue'),
  },
];

export default notificationsBackofficeRoutes;
